// extracted by css-extract-rspack-plugin
export default {"root":"CmByZI","input":"cB59GN","dollar-icon":"QnvpgF","dollarIcon":"QnvpgF","apply-btn":"QB5KoP","applyBtn":"QB5KoP","applied":"fF_AFy","focused":"Furton"};